import React from 'react'
import { FlexGrid, FlexGridItem } from 'application/components/fragments/grid'
import { DialogMainContent } from 'application/components/fragments/dialog'
import DisplayStatement from './display_statement'

const DialogDefault = (props) => {
    const { dialog } = props
    const payload = dialog.payload
    return <DialogMainContent>
        <FlexGrid itemsCenter directionColumn>
            <FlexGridItem>
                <FlexGrid grow='0' justifyCenter>
                    <FlexGridItem>
                        <DisplayStatement {...payload} {...props} />
                    </FlexGridItem>
                </FlexGrid>
            </FlexGridItem>
        </FlexGrid>
    </DialogMainContent>
}

export default DialogDefault
